import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  let authReq = req;

  // Jangan tambahkan header Authorization pada request login publik
  const isLoginEndpoint = req.url.includes('/api/v1/auth/login');

  if (token && !isLoginEndpoint) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Jika token expired / invalid pada request yang diproteksi, bersihkan sesi
      if (error.status === 401 && !isLoginEndpoint) {
        authService.clearSession();
      }
      return throwError(() => error);
    })
  );
};
